import { z } from 'zod'

const ERROR_MESSAGE = 'Please enter a valid email address.'

export const EmailFormSchema = z.object({
  email: z
    .string({ message: ERROR_MESSAGE })
    .min(1, { message: ERROR_MESSAGE })
    .email({ message: ERROR_MESSAGE })
})
